/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AccountDetails_stripe_Customer$ref = any;
export type AccountDetailsContainerQueryVariables = {||};
export type AccountDetailsContainerQueryResponse = {|
  +stripeCustomer: ?{|
    +$fragmentRefs: AccountDetails_stripe_Customer$ref
  |}
|};
export type AccountDetailsContainerQuery = {|
  variables: AccountDetailsContainerQueryVariables,
  response: AccountDetailsContainerQueryResponse,
|};
*/


/*
query AccountDetailsContainerQuery {
  stripeCustomer {
    ...AccountDetails_stripe_Customer
    id
  }
}

fragment AccountDetails_stripe_Customer on StripeCustomerNode {
  id
  customer_id
  customer_portal_url
}
*/

const node/*: ConcreteRequest*/ = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountDetailsContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StripeCustomerNode",
        "kind": "LinkedField",
        "name": "stripeCustomer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AccountDetails_stripe_Customer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AccountDetailsContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StripeCustomerNode",
        "kind": "LinkedField",
        "name": "stripeCustomer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customer_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customer_portal_url",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c7c3dc7150bcd88c43dc2545506d7892",
    "id": null,
    "metadata": {},
    "name": "AccountDetailsContainerQuery",
    "operationKind": "query",
    "text": "query AccountDetailsContainerQuery {\n  stripeCustomer {\n    ...AccountDetails_stripe_Customer\n    id\n  }\n}\n\nfragment AccountDetails_stripe_Customer on StripeCustomerNode {\n  id\n  customer_id\n  customer_portal_url\n}\n"
  }
};
// prettier-ignore
(node/*: any*/).hash = '0e07b991fb06e4636ac4de35d6a31520';

module.exports = node;
